<template>
    <span>
        {{ entityName }}
    </span>
</template>

<script lang="ts" setup>
import { EntityType, useEntityStore } from "@/stores/entity-store";
import { computed } from "vue";

const props = defineProps<{
    entityId: string;
    entityType: EntityType;
}>();

const entityStore = useEntityStore(props.entityType, props.entityId);
const store = entityStore();

const entityName = computed(() => {
    if (store.name && store.name !== "unknown") {
        return store.name;
    }

    return props.entityId;
});
</script>
